'use strict';
import { connect } from 'react-redux';
import
{
	articleSelector,
	resourceStatusSelector,
	editorialBottomTeasersSelector
} from '../../selectors';

const React = require('react');
const PageLoader = require('../PageLoader');
const { loadArticlepage } = require('../../actions');
const { List } = require('immutable');
const executeLoadActions = require('../../addons/executeLoadActions');
const EditorialBottomTeasers = require('../Editorial/EditorialBottomTeasers');
const Article = require('../Editorial');
class ArticleHandler extends React.Component {
	render() {

		if(this.props.status === 'RESOURCE_STATUS_FETCHING') {
			return (
				<PageLoader key={`loading-${this.props.params.article}`}/>
			);
		}

		return (
			<div>
				<Article article={this.props.article} key={`article-${this.props.params.article}`} />
				<EditorialBottomTeasers editorials={this.props.teasers.get('editorials', List())} currentPath={this.props.params.article} />
			</div>
		);
	}
}

ArticleHandler.handlerActions = [loadArticlepage];
ArticleHandler.contextTypes = {
	store: React.PropTypes.object.isRequired
};

function select(state, props) {
	return {
		status: resourceStatusSelector(state, { type:'articles', id:props.params.article }),
		article: articleSelector(state, { type:'articles', id:props.params.article }),
		teasers: editorialBottomTeasersSelector(state)
	};
}
export default connect(select)(executeLoadActions(ArticleHandler));



/** WEBPACK FOOTER **
 ** ./app/components/ArticleHandler/index.js
 **/